import { Query } from '@varo/graphql-schema-types';
import {
  isAdvanceBackupPaymentError,
  isAdvanceBackupPaymentSuccess,
} from 'features/advance/helpers/Advance.helpers';
import { useCallback } from 'react';
import BackupPaymentMethods from 'services/graphql/queries/BackupPaymentMethods';
import { RequestPolicy, useQuery } from 'urql';

const useBackupPayments = (
  requestPolicy: RequestPolicy = 'cache-and-network',
) => {
  const [response, refetchData] = useQuery<Query>({
    query: BackupPaymentMethods,
    requestPolicy,
  });

  const refetch = useCallback(
    (requestPolicy: RequestPolicy = 'network-only'): void => {
      refetchData({
        requestPolicy,
      });
    },
    [refetchData],
  );

  const { data, fetching, error } = response;

  const backupPaymentMethodsError = isAdvanceBackupPaymentError(
    data?.advanceBackupPaymentMethods,
  )
    ? data.advanceBackupPaymentMethods
    : undefined;

  const advanceBackupPaymentSuccess = isAdvanceBackupPaymentSuccess(
    data?.advanceBackupPaymentMethods,
  )
    ? data.advanceBackupPaymentMethods
    : undefined;

  const methods = advanceBackupPaymentSuccess?.methods;

  return {
    result: methods,
    fetching,
    error: backupPaymentMethodsError || error,
    refetch,
  };
};

export default useBackupPayments;
